var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TooltipTopBar } from '../../app-builder/utils/tooltipConfig';
export var InfoTooltip = function (_a) {
    var info = _a.info;
    return (_jsx(TooltipTopBar, __assign({ title: info }, { children: _jsx(FontAwesomeIcon, { color: "#999", icon: faInfoCircle, style: { cursor: 'pointer', fontSize: '12px' } }) })));
};
